module.exports = __webpack_public_path__ + "img/play-circle.01adad4c.svg";